module.exports = __webpack_public_path__ + "img/icon_patent_tr.b5e9c1ff.png";